import i18n from "./i18n";

export function getGreeting(name: string | undefined): string {
  if (!name) return "";
  const currentHour = new Date().getHours();

  let emoji = "🌙";
  if (currentHour >= 0 && currentHour < 12) {
    emoji = "🌄";
    return `${emoji} ${i18n.t("home.good_morning", { name:` ${name} ` })}`;
  } else if (currentHour >= 12 && currentHour < 15) {
    emoji = "🌞";
    return `${emoji} ${i18n.t("home.good_afternoon",  { name:` ${name} ` })}`;
  } else {
    return `${emoji} ${i18n.t("home.good_evening",  { name:` ${name} ` })}`;
  }
}
